"use strict";
// packages/contracts/src/relatorios.ts — Fase 03, Plano 09 (REL-03, RF-98).
// Contratos do motor de relatórios, descritores, jobs BullMQ e formulário de filtros.
Object.defineProperty(exports, "__esModule", { value: true });
exports.RELATORIOS_DISPONIVEIS = void 0;
/** Consultas com executor disponível; catálogo também contém entregas ainda em preparação. */
exports.RELATORIOS_DISPONIVEIS = ['R01', 'R02', 'R03', 'R04', 'R05', 'R06', 'R07', 'R08', 'R09', 'R10', 'R11', 'R12', 'R13', 'R14', 'R15', 'R16', 'A01', 'A02', 'A03', 'A04', 'A05', 'A06'];
//# sourceMappingURL=relatorios.js.map